
// ********* Import CSS ***************** //

import "./donate.css";

// ********* Import Images ***************** //

//*** ASATTC Spinner Image ***//
import "../assets/asattc-round-favicon/asattc-round-favicon.png";

// ** LOGO ** //
import "../assets/logos/asattc-logo-black.png";

// ** IMAGES ** //
import "../assets/asattc-images/asattc-students-with-icons-1.png";

// ********* Add Top Nav & Footer *************** //

import '../nav-header-footer/nav-header-footer.js';
import '../nav-header-footer/nav-header-footer.css';

// ************ Add Email Signup *************** //

import '../nav-header-footer/email-contact-events.js';

// **************************** Spinner ****************************** //

$(window).on('load', function(){
  document.getElementById("spinner").style.display = "block";
  setTimeout(removeSpinner, 1000);
});

function removeSpinner(){
  $( "#spinner" ).fadeOut(100, function() {
    $( "#spinner" ).remove();
  });
}